var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"basic-layout"},[_c('my-header'),_c('my-bread'),_c('main',{staticClass:"container flexable no-hidden"},[_c('my-menu',{class:{ collapse: _vm.isCollapsed }}),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }